/** Title-case a mid-sentence phrase, keeping brands (FlowOx) and acronyms (ACL). */
function titleCasePhrase(phrase: string): string {
    return phrase
        .split(" ")
        .filter(Boolean)
        .map((word) => {
            if (/[a-z]/.test(word) && /[A-Z]/.test(word.slice(1))) return word;
            const letters = word.replace(/[^A-Za-z]/g, "");
            if (letters.length >= 2 && letters === letters.toUpperCase()) return word;
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
}

export const journeyCopyEn = {
    profileCompleteTitle: "Profile complete",
    profileCompleteStatusLabel: "Profile saved",
    profileCompleteConsentDescription: "Your profile details have been saved. Next we will review consent.",
    profileCompleteSetupDescription:
        "Your profile details have been saved. Next we need your treatment set-up details.",
    profileCompleteFormsDescription: "Your profile details have been saved. Next you can complete your forms.",
    profileCompleteDiaryDescription: "Your profile details have been saved.",
    consentCompleteTitle: "Consent complete",
    consentCompleteStatusLabel: "Consent signed",
    consentCompleteSetupDescription:
        "Your consent choices have been recorded. Now we just need your treatment set-up details.",
    consentCompleteFormsDescription: "Your consent choices have been recorded. Next you can complete your forms.",
    consentCompleteDiaryDescription: "Your consent choices have been recorded.",
    setupCompleteTitle: "Set-up complete",
    setupCompleteStatusLabel: "Set-up saved",
    setupCompleteConsentDescription: "Next we will review consent.",
    setupCompleteFormsDescription: "Your treatment details are ready. Next you can complete your first forms.",
    setupCompleteDiaryDescription: "Your treatment details are ready.",
    formCompleteTitle: "Form complete",
    formCompleteNextDescription: "Your response has been saved. You can continue to the next entry.",
    formCompleteAllDoneDescription:
        "Your response has been saved. You are up to date for now. You can view your results.",
    formCompleteAllCaughtUpTitle: "All up to date",
    formCompleteAllCaughtUpNextDue: (date) => `Next due at ${date}`,
    formCompleteNextEntryDue: (scheduleLabel, date) => `Your ${scheduleLabel.toLowerCase()} entry is due on ${date}.`,
    formCompleteStatusSuffix: "complete",
    continueToNextForm: "Next",
    goToConsent: "Go to Consent",
    goToSetup: "Go to Set-up",
    knowProcedureDateYetTitle: "Do you know the date yet?",
    knowProcedureDateYetMessage:
        "Add your procedure date when you know it so follow-up questions line up with your treatment.",
    addProcedureDate: "Add Procedure Date",
    addHospitalNumber: "Add Hospital Number",
    addSide: "Add Side",
    addEventDate: (eventPhrase) => `Add ${titleCasePhrase(eventPhrase)} Date`,
    reviewConsent: "Review consent",
    shortcutsHeading: "Still to do:",
    goToForms: "Go to Forms",
    goToYourDiary: "Go to your diary",
    goToYourResults: "Go to your results",
    seeCharts: "See Charts",
    phaseProfile: "Profile",
    phaseSetup: "Set-up",
    phaseConsent: "Consent",
    phaseForms: "Forms",
    phaseDiary: "Diary",
    setupHospitalNumber: "Hospital number",
    setupProcedureDate: "Procedure date",
    setupSide: "Side",
    loadingProgress: "Loading progress...",
    progressTitle: "Your progress",
    dismissProgress: "Close progress",
    currentStage: "Current stage",
    stepProgressAriaLabel: (stepLabel) => `${stepLabel} progress`,
    stepOf: "of",
    nextStep: "Next step",
    formsDoneCount: (done, total) => `${done} of ${total} forms done`,
    diaryStillSettingUp: "Your diary is still being set up. This can take a moment.",
    tryAgain: "Try again",
};
